<template>
  <nav>
    <div v-if="surveyOverview">
      <v-row  no-gutters class="text-left">
        <v-col cols="12" class="d-inline-flex mb-3">
          <p class="text-subtitle-1 no-break font-weight-bold" v-html="question.question"></p>
        </v-col>
        <v-col cols="12" class="mb-3" v-if="question.description && strip(question.description).trim() != ''">
          <p
            class="text-subtitle-2 font-weight-regular greytext--text no-break"
            v-html="question.description"
          ></p>
        </v-col>
     </v-row>
      <div class="survey-question-image-editor mb-3">
        <img
          v-if="question.imageDisplay != null"
          :src="question.imageDisplay"
          :path="question.image"
          class="custom-image large"
          crossorigin="*"
        />
        <img
          v-else
          src="/assets/editor_images/surveyimagequestion.jpg"
          class="custom-image large"
          crossorigin="*"
        />
      </div>
        <v-row
        align="center"
        justify="center"
        data-testid="survey-1"
        class="mt-5 mb-3"
      >
        <v-col cols="12" sm="12" :md="pdf ? 9 : 7">
      <v-list-item v-for="answer in question.options" :key="answer.aid">
        <v-text-field
          disabled
          readonly
          dense
          solo
          elevation="8"
          class="survey-answer survey-answer-progress rounded-lg text-body-2 mr-4 replace-box-shadow-input"
          hide-details="auto"
        >
          <template v-slot:prepend-inner>
            <v-icon class="icon-des my-2" color="greytext"
              >mdi-checkbox-blank-outline</v-icon
            >
            <p
              data-testid="select-answer"
              class="font-weight-regular greytext--text text-body-2 my-2 ml-2 align-self-center no-break"
            >
              {{ answer.option }}
            </p>
            <v-progress-linear
              v-if="
                question.stats &&
                question.stats.hasOwnProperty(answer.aid) &&
                question.stats[answer.aid]
              "
              :value="calculatePercentage(question.stats[answer.aid], numbSubmissions)"
              height="100%"
              color="accent"
              class="progress-bar"
              absolute
              top
              left="0"
              right="0"
            ></v-progress-linear>
          </template>
          <template v-slot:append-outer>
            <div
          v-if="
            question.stats &&
            question.stats.hasOwnProperty(answer.aid) &&
            question.stats[answer.aid]
          "
        >
          <span
            >{{
              calculatePercentage(question.stats[answer.aid], numbSubmissions)
            }}%</span
          >
        </div>
        <div v-else><span>0%</span></div>
          </template>
        </v-text-field>
      </v-list-item>
        </v-col>
        </v-row>
    </div>
     <div v-else-if="user">
      <v-row no-gutters class="text-left">
        <v-col cols="12" class="d-inline-flex mb-3">
          <p
            class="text-subtitle-1 no-break font-weight-bold"
            v-html="question.question"
          ></p>
        </v-col>
        <v-col cols="12" class="mb-3" v-if="question.description && strip(question.description).trim() != ''">
          <p
            class="text-subtitle-2 font-weight-regular greytext--text no-break"
            v-html="question.description"
          ></p>
        </v-col>
      </v-row>
      <div class="survey-question-image-editor mb-3">
        <img
          v-if="question.imageDisplay != null"
          :src="question.imageDisplay"
          :path="question.image"
          class="custom-image large"
          crossorigin="*"
        />
        <img
          v-else
          src="/assets/editor_images/surveyimagequestion.jpg"
          class="custom-image large"
          crossorigin="*"
        />
      </div>
      <v-row
        align="center"
        justify="center"
        data-testid="survey-1"
        class="mt-5 mb-3"
      >
        <v-col cols="12" sm="12" :md="pdf ? 9 : 7">
          <v-list-item v-for="answer in question.options" :key="answer.aid">
            <v-text-field
              disabled
              readonly
              dense
              solo
              elevation="8"
              :class="
                user[question.qid].answer.includes(answer.aid)
                  ? 'survey-answer-individual rounded-lg text-body-2 mr-4'
                  : 'survey-answer rounded-lg text-body-2 mr-4'
              "
              hide-details="auto"
              class="replace-box-shadow-input"
            >
              <template v-slot:prepend-inner>
                <!-- Check if the current answer's aid exists in the object's answer array -->
                <v-icon
                  v-if="user[question.qid].answer.includes(answer.aid)"
                  class="icon-des my-2 row-pointer"
                  color="accent"
                >
                  mdi-checkbox-outline
                </v-icon>
                <v-icon
                  v-else
                  class="icon-des my-2 row-pointer"
                  color="greytext"
                >
                  mdi-checkbox-blank-outline
                </v-icon>
                <p
                  data-testid="select-answer"
                  class="font-weight-regular greytext--text text-body-2 my-2 ml-2 align-self-center no-break row-pointer"
                >
                  {{ answer.option }}
                </p>
              </template>
            </v-text-field>
          </v-list-item>
        </v-col>
      </v-row>
    </div>
    <div v-else>
      <editor-survey
        ref="editImage"
        class="survey-question-image-editor"
        data-testid="image-editor"
        :content="
          question.imageDisplay != null
            ? `<img src=&quot;` +
              question.imageDisplay +
              `&quot; path=&quot;` +
              question.image +
              `&quot;></editor-survey>`
            : `<img src=&quot;/assets/editor_images/surveyimagequestion.jpg&quot;>`
        "
        :index="index"
        type="question"
        part="image"
        @proceedClick="setEditor"
        @updateSurvey="updateSurveyImage"
        @proceedMark="showHideEditorTextOptions"
        @enableEditMode="enableEditMode"
        @showErrorMessage="showErrorMessageImage"
      />
      <div
        v-visible="question.errorImage && question.imageDisplay == null"
        class="error--text text-caption text-left"
      >
        {{ $t("imageErrorRequired") }}
      </div>
      <draggable
        :list="question.options"
        class="list-group pl-0 mt-5"
        ghost-class="ghost-block-answer"
        :force-fallback="true"
        :disabled="published"
        handle=".handle"
      >
        <v-list-item
          v-for="(answer, answerIndex) in question.options"
          :key="answer.aid"
        >
          <v-hover>
            <template v-slot:default="{ hover }">
              <v-text-field
                dense
                solo
                v-model="answer.option"
                class="survey-answer rounded-lg text-body-2"
                hide-details="auto"
                :placeholder="$t('surveyTextChoicePlaceholder')"
                :rules="inputRules"
                @click="resetEditor()"
                @keyup.enter="focusNext($event.target)"
              >
                <template v-slot:prepend>
                  <v-icon class="handle" @click="resetEditor()"
                    >mdi-drag-vertical</v-icon
                  >
                </template>
                <template v-slot:prepend-inner>
                  <v-icon class="handle" @click="resetEditor()"
                    >mdi-checkbox-blank-outline</v-icon
                  >
                </template>
                <template v-slot:append v-if="!published">
                  <v-icon
                    v-if="hover && question.options.length > 2"
                    @click="deleteAnswer(question, answerIndex)"
                    data-testid="delete-button"
                    >mdi-delete-circle</v-icon
                  >
                </template>
              </v-text-field>
            </template>
          </v-hover>
        </v-list-item>
      </draggable>
    </div>
  </nav>
</template>
<script>
import draggable from "vuedraggable";
import {
  ruleRequired,
  answerRuleValid,
} from "../../../rules/formRules.js";
import EditorSurvey from "../../EditorSurvey";
import { repeatedMethodsMixin } from "../../../mixins/repeatedMethodsMixin";

export default {
  props: {
    question: {
      type: Object,
      default: () => {},
    },
    index: {
      type: Number,
      default: 0,
    },
    published: {
      type: Boolean,
      default: false,
    },
    surveyOverview: {
      type: Boolean,
      default: false,
    },
     numbSubmissions: {
      type: Number,
      default: 0,
    },
     user: {
      type: Object,
      default: () => {},
    },
    pdf: {
      type: Boolean,
      default: false,
    }
  },
  components: {
    draggable,
    EditorSurvey,
  },
  mixins: [repeatedMethodsMixin],
  data() {
    return {
      focusNext(e) {
        const inputs = Array.from(
          e.form.querySelectorAll('input[type="text"]')
        );
        const index = inputs.indexOf(e);
        if (index < inputs.length && inputs[index + 1]) {
          inputs[index + 1].focus();
        }
      },
      inputRules: ruleRequired('labelAnswer').concat(answerRuleValid)
    };
  },

  methods: {
    deleteAnswer(question, answerIndex) {
      this.resetEditor();
      this.$emit("deleteAnswer", question, answerIndex);
    },
    resetEditor() {
      this.$emit("resetEditor");
    },
    setEditor(editor) {
      this.$emit("setEditor", editor);
    },
    updateSurveyImage(type, index, answerIndex, content) {
      this.$emit("updateSurveyImage", type, index, answerIndex, content);
    },
    showHideEditorTextOptions(val) {
      this.$emit("showHideEditorTextOptions", val);
    },
    enableEditMode() {
      this.$emit("enableEditMode");
    },
    showErrorMessageImage(index, answerIndex, type) {
      this.$emit("showErrorMessageImage", index, answerIndex, type);
    }
  },
};
</script>
